import { put } from '../../Shared/ajax';
import PageState from '../../Shared/pageState';
import { getErrorMessage } from '../../Shared/errorHandling';

interface UpdatePagesResponse {
  lastModifyDate: string;
  lastModifyBy: string;
}

interface UpdatePagesRequest {
  pages: UpdatePagesRequestPage[];
}

interface UpdatePagesRequestPage {
  externalId: string;
  metadata: string;
}

const saveRetrievedPageUpgrades = async (pages: PageState[]) => {
  try {
    const payload: UpdatePagesRequestPage[] = pages.map((p) => ({
      externalId: p.id,
      metadata: JSON.stringify(p.schema)
    }));

    const response = await put<UpdatePagesResponse, UpdatePagesRequest>(
      'DynamicWorkflowPage/UpdatePages',
      {
        pages: payload
      }
    );

    return response;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(getErrorMessage(err));
  }
};

export default saveRetrievedPageUpgrades;
